<template>
	<div class="widget-view" style="overflow-y:auto" :class="{active: selectWidget.key == element.key}" v-if="element && element.key">
		<dynamic-link
      :type="element.component"
      :componentname="element.name"
      :comData="element.options|transObj"
      :style="{height:data.config?data.config.height:''}"
      @click.native.stop="handleSelectWidget(index)"
      @AfterRendering="AfterRendering">
      <template :slot="key" v-for="(val,key) in $slots">
        <slot :name="key"></slot>
      </template>
    </dynamic-link>
		<div class="widget-view-action" v-if="selectWidget.key == element.key">
      <i class="el-icon-copy-document" @click.stop="handleWidgetClone(index)"></i>
      <i class="el-icon-delete" @click.stop="handleWidgetDelete(index)"></i>
    </div>
    <div class="widget-view-drag" v-if="selectWidget.key == element.key">
      <i class="el-icon-rank drag-widget drag-widget"></i>
    </div>
	</div>
</template>

<script>
  /**
   *宋建国：2020/2/1 18:05
   *描述：为解决vue过滤器中无法使用this而定义的组件内全局变量
   *版本：1.0
   */
  let self = this;
	export default {
		props:['element','select','index','data','isAdd'],
		data(){
			return {
        selectWidget: this.select
			}
		},
		watch: {
	    select (val) {
	      this.selectWidget = val
	    },
	    selectWidget: {
	      handler (val) {
	        this.$emit('update:select', val)
	      },
	      deep: true
	    }
	  },
	  filters:{
	  	transObj(val){
        /**
         *宋建国：2020/1/31 12:44
         *描述：转换对象
         *版本：1.0
         */
	  		function fact(data){
          let _obj = {};
          // 表格初始化时查询条件
          let initobj = {}
          // 外部的注入额外的查询参数
          let custobj = {}
	  			data.forEach(_item => {
	  				if(_item.list && _item.list.length > 0){
	  					_obj[_item.attrName] = fact(_item.list);
	  				}else if(_item.arrays && _item.arrays.length>0) {
              _obj[_item.attrName] = arrayConvert(_item.arrays);
            }else if(_item.attrName){
              _obj[_item.attrName] = _item.value
            }
          })
          // 如果没有设置排序条件就不传排序到表格中
          if(_obj.sorter && _obj.sorter.length>0){
            _obj.sorter = _obj.sorter.filter(s => s.direction && s.property)
          }
          // 表格初始化时查询条件
          if(_obj.InitQuery && _obj.InitQuery.length>0){
            let arr = []
            arr = _obj.InitQuery.filter(init => init.andor && init.field && init.gx && init.value)
            arr.forEach((q,t) => {
              initobj[t] = {}
              for(let o in q){
                initobj[t][o+t] = q[o]
              }
            })
            _obj.InitQuery = initobj
          }
          // 外部的注入额外的查询参数
          if(_obj.customQuery && _obj.customQuery.length>0){
            let ary = []
            ary = _obj.customQuery.filter(cust => cust.andor && cust.field && cust.gx && cust.value)
            ary.forEach((cu,c) => {
              custobj[(100+c)] = {}
              for(let o in cu){
                custobj[100+c][o+(100+c)] = cu[o]
              }
            })
            _obj.customQuery = custobj
          }
	  			return _obj;
	  		}

        /**
         *宋建国：2020/1/31 12:45
         *描述：转换数组
         *版本：1.0
         */
	  		function arrayConvert(arrays) {
          let _arrays = [];
          let _obj = {}
          for(let i=0; i<arrays.length; i++){
            if(arrays[i].list && arrays[i].list.length > 0){
              _obj[arrays[i].attrName] = fact(arrays[i].list);
            }else if(arrays[i].arrays && arrays[i].arrays.length>0) {
              _obj[arrays[i].attrName] = arrayConvert(arrays[i].arrays);
            }else if(Array.isArray(arrays[i])){
              _arrays.push(fact(arrays[i]));
            }else if(arrays[i].attrName){
              _obj[arrays[i].attrName] = arrays[i].value;
            }
          }
          if(!self.$tu.isObjectBlank(_obj)){
            _arrays.push(_obj);
          }
          return _arrays;
        }
				if(val){
					let obj = {};
					val.forEach(item => {
	          if(item.arrays && item.arrays.length>0){
	            obj[item.attrName] = arrayConvert(item.arrays)
	          }else if(item.list && item.list.length > 0){
	          	obj[item.attrName] = fact(item.list)
	          }else if(item.attrName){
	            obj[item.attrName] = item.value
	          }
          });
					return obj;
				}
	  	}
	  },
		methods:{
			RecursionConfig(config,props){
        /**
         *宋建国：2020/2/1 11:03
         *描述：设置数组类型数据，初始化组件中props的对应数组默认值，根据两数组下标进行赋值操作
         *版本：1.0
         */
			  function ConfigArrayValue(subconfig,subprops,attrName) {
			    if(subconfig.length==0){
			      this.$message.error('请在组件的xyjconfig中,对props的'+attrName+'变量，设置一个属性设置数据');
            return;
          }
			    //设置数组数据中只存留第一个下标数据，删除其他部分
          subconfig.splice(1,subconfig.length-1);
			    for(let i=1; i<subprops.length; i++){
            let item = this.$tu.xyjClone(subconfig[0]);
            subconfig.push(item);
          }
			    //组件设置数组
          for(let ci=0; ci<subconfig.length; ci++) {
            //处理组件中xyjconfig设置属性少，但props中的默认数据多情况
            if (!this.$tu.isBlank(subprops[ci])) {
              for (let cj = 0; cj < subconfig[ci].length; cj++) {
                if (!this.$tu.isBlank(subconfig[ci][cj].attrName)) {
                  if (subconfig[ci][cj].list && subconfig[ci][cj].list.length > 0) {
                    
                    this.RecursionConfig(subconfig[ci][cj].list, subprops[ci][subconfig[ci][cj].attrName]);
                  } else if (subconfig[ci][cj].arrays && subconfig[ci][cj].arrays.length > 0) {
                    ConfigArrayValue.call(this, subconfig[ci][cj].arrays, subprops[ci][config[ci][cj].attrName],config[ci][cj].attrName);
                  } else {
                    subconfig[ci][cj].value = subprops[ci][subconfig[ci][cj].attrName];
                  }
                }
              }
            }
          }
        }
	      for(let i=0; i<config.length; i++){
	        if(!this.$tu.isBlank(config[i].attrName)){
	          if(config[i].list && config[i].list.length>0 && props){
	            this.RecursionConfig(config[i].list,props[config[i].attrName]);
	          }else if(config[i].arrays && config[i].arrays.length>0 && props){
              ConfigArrayValue.call(this,config[i].arrays,props[config[i].attrName],config[i].attrName);
	          }else{
              if(props){
                config[i].value = props[config[i].attrName];
              }
            }
	        }
	      }
	    },
      /**
       *宋建国：2020/2/1 11:35
       *描述：远程组件渲染完成后执行事件
       *版本：1.0
       */
			AfterRendering(elementName,component){
        if(this.$tu.isObjectBlank(component)){
          console.error('请在远程组件'+elementName+'中的“AfterRendering”事件传出VEU实例this');
          return;
        }
        if(!this.$tu.isFunction(component.$options['xyjconfig'])){
          console.error('远程组件'+elementName+'，没有编写配置函数，无拖拽配置');
          return;
        }
        let vueData = component.$options.xyjconfig();
        if(this.$tu.isObjectBlank(vueData)){
          return;
        }
        let compConfig = vueData['attr'];
        // if(compConfig.length == 0){
        //   console.error('远程组件'+elementName+'，配置数据中请设置attr属性');
        //   return;
        // }
        if(this.$tu.isObjectBlank(compConfig)){
          console.error('远程组件'+elementName+'，配置数据中请设置attr属性');
          return;
        }
        //if(this.isAdd){
          this.RecursionConfig(compConfig,component['_props']);
          //下边，处理组件设置默认属性
          //栅格布局
          if(this.data.list[this.data.list.length-1].type == 'grid'){
            // this.data.list[this.data.list.length-1].options.filter(x => x.attrName == 'grid')[0].group[this.col.colIndexNum].list[this.col.newIndexNum].options = compConfig;
            this.data.list.filter(item => item.key == this.selectWidget.key)[0].options.filter(x => x.attrName == 'grid')[0].group[this.col.colIndexNum].list[this.col.newIndexNum].options = compConfig;
          }else if(this.data.list[this.data.list.length-1].type == 'tabs'){
            // this.data.list[this.data.list.length-1].options.filter(x => x.attrName == 'tabChange')[0].group[this.tab.colIndexNum].list[this.tab.newIndexNum].options = compConfig;
            this.data.list.filter(item => item.key == this.selectWidget.key)[0].options.filter(x => x.attrName == 'tabChange')[0].group[this.tab.colIndexNum].list[this.tab.newIndexNum].options = compConfig;
          }else{
            // this.data.list[this.data.list.length-1].options = compConfig
            this.data.list.filter(item => item.key == this.selectWidget.key)[0].options = compConfig
          }
        //}
      },
			handleSelectWidget(index){
        this.selectWidget = this.data.list[index]
			},
			handleWidgetClone (index) {
	      let cloneData = {
	        ...this.data.list[index],
	        options: [...this.data.list[index].options],
	        key: Date.parse(new Date()) + '_' + Math.ceil(Math.random() * 99999)
	      }
	
	      if (this.data.list[index].type === 'radio' || this.data.list[index].type === 'checkbox') {
	
	        cloneData = {
	          ...cloneData,
	          options: {
	            ...cloneData.options,
	            options: cloneData.options.options.map(item => ({...item}))
	          }
	        }
	      }
	
	      this.data.list.splice(index, 0, cloneData)
	
	      this.$nextTick(() => {
	        this.selectWidget = this.data.list[index + 1]
	      })
	    },
	    handleWidgetDelete (index) {
	      if (this.data.list.length - 1 === index) {
	        if (index === 0) {
	          this.selectWidget = {}
	        } else {
	          this.selectWidget = this.data.list[index - 1]
	        }
	      } else {
	        this.selectWidget = this.data.list[index + 1]
	      }
	
	      this.$nextTick(() => {
	        this.data.list.splice(index, 1)
	      })
	    },
		},
    beforeCreate() {
      /**
       *宋建国：2020/2/1 18:03
       *描述：为解决vue过滤器中无法使用this而定义的组件内全局变量，初始化self为this对象
       *版本：1.0
       */
      self = this;
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/vueformmaking/dynamicItem.vue